// extracted by mini-css-extract-plugin
export default {"form-row":"FormRow_form-row__3ioWe","label":"FormRow_label__ZOIpu","content":"FormRow_content__j0UW0","text":"FormRow_text__O20lw","error":"FormRow_error__Fut2r"};